export const SearchDebounceMs = 500;
export const ClientsSearchLimit = 20;

export const getClientPhone = (client) => client.phone_with_country_code || client.phone;
export const getClientDisplayName = (client) => client.name || `${client.first_name} ${client.last_name}`;

export const appendCallingPermissionToClient = (client, callingPermission) => ({
  ...client,
  callingPermission
});
